module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.4-143.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.9.4.md
// module id = 561
// module chunks = 223